<div class="wrapper-md">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{title}}
            <app-vaccination-document-status [value]="'Draft'"></app-vaccination-document-status>
        </h1>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <form #form="ngForm" *ngIf="!studentPickerOpened">
        <div class="row" *ngIf="canPickStudent">
            <div class="form-field col-md-8 required">
                <label class="form-label">{{'vaccinationDocument_lblStudent' | translate}}</label>
                <div class="input-group">
                    <input class="form-control" [value]="studentDisplay" disabled required />
                    <button class="btn btn-outline" type="button" (click)="studentPickerOpened = true">
                        <i class="fi fi-rs-pencil"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-field required col-md-6">
                <label class="form-label">{{'vaccinationDocument_lblType' | translate}}</label>
                <app-select [(ngModel)]="model.TypeId"
                            [options]="types"
                            [displayProperty]="'Value'"
                            [valueProperty]="'Id'"
                            [required]="true"
                            [disabled]="document?.IsAutoGenerated"
                            name="type">
                </app-select>
            </div>
        </div>

        <div class="row" *ngIf="showPolicyNumber">
            <div class="form-field required col-md-4">
                <label class="form-label">{{'vaccinationDocument_lblPolicyNumber' | translate}}</label>
                <input class="form-control" [(ngModel)]="model.PolicyNumber" name="policyNumber" required maxlength="50">
            </div>
        </div>

        <div class="row" *ngIf="showExpires">
            <div class="form-field required col-md-4">
                <label class="form-label">{{'vaccinationDocument_lblExpires' | translate}}</label>
                <app-date [(ngModel)]="model.Expires"
                          name="expires"
                          [required]="true"></app-date>
            </div>
        </div>

        <div class="form-field">
            <label class="form-label">{{'vaccinationDocument_lblNotes' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="model.Notes" name="notes" rows="5" #notesInput="ngModel"
                      [pattern]="getMaxLengthValidationPattern(model.Notes, notesMaxLength)"></textarea>
            <div class="feedback" *ngIf="!model.Notes?.length || notesInput.valid">{{(model.Notes || '').length}}/{{notesMaxLength}}</div>
            <div class="invalid-feedback" *ngIf="model.Notes?.length && notesInput.invalid">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, notesMaxLength]}}
            </div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'vaccinationDocument_lblFile' | translate}}</label>
            <div class="d-flex">
                <div class="flex-grow-1">
                    <app-file [(ngModel)]="model.File"
                              [accept]="attachmentExtensions"
                              [maxSize]="attachmentMaxSize"
                              [required]="true"
                              name="file"></app-file>
                </div>

                <button class="btn btn-outline btn-icon ms-3" *ngIf="model.File?.size == 0"
                        (click)="download()" [ngbTooltip]="'download' | translate">
                    <i class="fi fi-rs-download"></i>
                </button>
            </div>
        </div>

        <div class="form-actions">
            <span class="form-actions-group">
                <button class="btn btn-outline-primary" type="button" (click)="save(true)" [disabled]="!form.valid">
                    <i class="fi fi-rs-paper-plane"></i>
                    {{'vaccinationDocument_btnSubmit' | translate}}
                </button>
            </span>

            <span class="form-actions-group">
                <button class="btn btn-outline" type="button" [routerLink]="['/vaccination-documents'] | localize">
                    {{'vaccinationDocument_btnClose' | translate}}
                </button>

                <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!form.valid">
                    {{'vaccinationDocument_btnSave' | translate}}
                </button>
            </span>
        </div>
    </form>
</div>
